






















































































import { listFactory } from '@/main/pages';

import { convertToObjects, Row, EditableStatus } from '@/main/utils/table';
import { Partner } from '@/modules/kartoteka/partner';
import { showAlert } from '@/main/utils/notifications';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';
import DmsEditableTableCell from '#components/dms/layout/EditableTableCell.vue';

import Save from '#components/dms/button/Save.vue';

import { CUSTOMER_ID, NAME, SPLIT_PARTIES, SPLIT_PARTY, PARTS, MAX_SHARE_PERCETAGE, DEFAULT, DEALER, DEFAULT_INDEX, COLUMN_DISCOUNT_PERCENT, COLUMN_DISCOUNT_AMOUNT } from './constants';

import { store } from './store/list';

import { apiProvider } from './api';

import { apiProvider as splitBillingApiProvider} from '../SplitBilling/api';

import { types } from './store/types';
import { ISplitPartyInvoiceDetail, SplitPartyType } from './store/SplitBillingDetails';
import { ZAKAZKA_STAV } from '../constants';

export default listFactory(NAME, store).extend({
	components: {
		PartnerSelect: Partner.components.Select,
		DmsEditableTable,
		DmsEditableTableCell,
		'dms-save': Save,
	},
	data() {
		return{
			oemName:'',
			dealerName:'',
			IsWarranty: false as boolean,
			IsGoodwill: false as boolean,
			defaultChargeTypeId: null as number | null,
			defaultDepartmentId: null as number | null,			
			hasStoredOriginalSharePercentageSum: false,
			hasStoredIsBilledStatus: false,				
			isFromServiceJobDetails: false,
			primaryCustomerId: null as number | null,		
		};
	},
	mounted() {
		// Hard page refresh issue handle
		if (!this.$route.params?.filter && this.$route.query) {
			const filter = {
				ServiceJobId: +this.$route.query.ServiceJobId,
				ServiceOrderId: +this.$route.query.ServiceOrderId,
				// ItemId: +this.$route.query.ItemId,
				// ItemType: this.$route.query.ItemType,
				Saga2Prp: this.$route.query.Saga2Prp === 'true',
				IsOrderSentToSaga: this.$route.query.IsOrderSentToSaga === 'true',
				FromServiceJobDetails: this.$route.query.FromServiceJobDetails,
				OrderStatus: this.$route.query.OrderStatus,
				IsServiceJobTagedLineItem: this.$route.query.IsServiceJobTagedLineItem,
				PrimaryCustomerId: +this.$route.query.PrimaryCustomerId,

			} as any;
			this.$route.params.filter = { ...filter };
			this.filter = { ...filter };
			this.props.filter = filter;
		}
		// Check if coming from ServiceJobDetails page		
		this.isFromServiceJobDetails = this.props.filter.FromServiceJobDetails === true;		
		this.getDropdownListForInternalSplit();
		this.getSplitPartyNames(+this.$route.query.ServiceOrderId);	
		//this.getDnp(+this.$route.query.ServiceJobId);
		this.getSplitPartyForOrder(+this.$route.query.ServiceOrderId);
		this.getPartyInvoicedDetails(+this.$route.query.ServiceOrderId);
		
	},
	computed: {
		isModified(): boolean {
			return this.table.isModified();
		},
		mutationsMapper(): Record<string, string> {
			return {
				customer: `${this.storeUri}/${types.mutations.SPLIT_CUSTOMER_LIST_MAPPER}`,
			};
		},
		isTableDataNotPresent(): boolean {
			return !this.table.rows?.length;
		},
		isWarrantyExist(): boolean {
			return this.isSplitPartyExist(SPLIT_PARTIES.Warranty)
			|| this.isSplitPartyExist(SPLIT_PARTIES.Goodwill)
			|| !this.IsWarranty
			|| (this.props.filter.IsOrderSentToSaga === true);
		},
		isGoodwillExist(): boolean {
			return this.isSplitPartyExist(SPLIT_PARTIES.Goodwill)
			|| this.isSplitPartyExist(SPLIT_PARTIES.Warranty)
			|| !this.IsGoodwill
			|| (this.props.filter.IsOrderSentToSaga === true);
		},
		
		isDealerExist(): boolean {
			return  this.isSplitPartyExist(SPLIT_PARTIES.Dealer);
		},
	},
	watch: {
		'table.rows': {
			handler() {
				// Calculate original share percentage sum once after initial async data load.
				if (this.table.rows?.length > 0) {
					this.initializeOriginalSharePercentageSum();
				}
				if(this.isFromServiceJobDetails) {
					this.checkIfCanAddNewSplitParty();
				}
			},
			deep: true,
		},

		'localState.splitPartyInvoiceDetails': {
			handler() {
				if(this.isFromServiceJobDetails) {
					this.checkIfCanAddNewSplitParty();
				}
			},
			deep: true,
		},
	},
	methods: {
		initializeOriginalSharePercentageSum(): void {
			// Calculate originalSharePercentageSum only once during initial page load
			if (!this.hasStoredOriginalSharePercentageSum && this.table.rows?.length > 0 && this.isFromServiceJobDetails) {
				const sum = parseFloat(this.sumOfSharePercentage().toFixed(2));
				this.localState.OriginalSharePercentageSum = sum;
				this.hasStoredOriginalSharePercentageSum = true;
			}
		},
		checkIfCanAddNewSplitParty(): void {
			if (this.table.rows?.length > 0  && this.hasStoredIsBilledStatus === false) {
				this.localState.canAddNewSplitParty = !(this.table.rows.every(row => row.cells[this.table.cellNames!.IS_BILLED] === true) &&
				this.isPrimaryCustomerInvoiced() === true);
				this.hasStoredIsBilledStatus = true;
			} else if(this.isPrimaryCustomerInvoiced() === true && this.props.filter.IsServiceJobTagedLineItem && (this.table.rows?.length === 0 || parseFloat(this.sumOfSharePercentage().toFixed(2)) === 0 || this.sumOfSharePercentage === null)) {
				this.localState.canAddNewSplitParty = false;
				this.hasStoredIsBilledStatus = true;
			} 
			
			else {
				this.localState.canAddNewSplitParty = true;
			}
		},
		async getSplitPartyNames(serviceOrderId:number | null){
			const response = await apiProvider.fetchSplitPartyNames(serviceOrderId);
			if(response.data)
			{
				this.oemName=response.data.OemName;
				this.dealerName=response.data.DealerName;
			}
		},
		getLocalizedText(text: string) {
			return this.LocalizePopisPoli(text);
		},
		async getDropdownListForInternalSplit() {
			const { data } = await splitBillingApiProvider.getDropdownListForInternalSplit();
			if (data) {
				this.dropdownList.InvoiceChargeTypes = data.Item1;
				this.dropdownList.InvoiceDepartments = data.Item2;
			 }
		},
		canEditRow(row: Row) {
			const splitPartyIndex = this.table.cellNames!.SPLIT_PARTY_ID;
			const partyType = row.cells[splitPartyIndex];
			const isInvoicedIndex = this.table.cellNames!.IS_BILLED;
			const isInvoiced = row.cells[isInvoicedIndex];
			if ( isInvoiced === true) {
				return false;
			}
			if ((partyType === SPLIT_PARTIES.Warranty || partyType === SPLIT_PARTIES.Goodwill) && (this.props.filter.IsOrderSentToSaga === true)) {				
				return false;
			}
				return true;
        },
		isSplitPartyExist(identifier: any, isCustomer = false): boolean {
			const tableData = convertToObjects(this.table);
			let isSplitPartyTypeExist = false;
			if (tableData && tableData.length) {
				let searchKey = SPLIT_PARTY;
				if (isCustomer) {
					searchKey = CUSTOMER_ID;
				}
				const splitParty = tableData.find(i => i[searchKey] === identifier);
				if (splitParty) {
					isSplitPartyTypeExist = true;
				} else {
					isSplitPartyTypeExist = false;
				}
			} else {
				isSplitPartyTypeExist = false;
			}
			return isSplitPartyTypeExist;
		},
		async getSplitPartyForOrder(orderId: number) {
			const { data: splitPartyData } = await apiProvider.getSplitPartyForOrder(orderId);
			this.IsWarranty = splitPartyData.IsWarranty;
			this.IsGoodwill = splitPartyData.IsGoodwill;
		},
		async handleSave() {
			try {
				this.startLoading();
				const sumOfSharePercentage = this.sumOfSharePercentage();
				const currentShareSum = parseFloat(sumOfSharePercentage.toFixed(2));
				const isPrimaryCustomerInvoiced = this.isPrimaryCustomerInvoiced();
				if (isPrimaryCustomerInvoiced && this.localState.OriginalSharePercentageSum !== null && currentShareSum !== this.localState.OriginalSharePercentageSum) {					
					this.showMessage(this.LocalizeChyboveHlasky('SHARE_PERCENTAGE_VALIDATION_IF_PRIMARY_INVOICED').replace('<Percent1>', this.localState.OriginalSharePercentageSum.toString()).replace('<Percent2>', currentShareSum.toString()));
					return;
				}
				if(isPrimaryCustomerInvoiced && this.localState.OriginalSharePercentageSum === null && currentShareSum !== 100) {
					this.showMessage(this.LocalizeChyboveHlasky('SHARE_PERCENTAGE_VALIDATION_IF_PRIMARY_INVOICED').replace('<Percent1>', '100').replace('<Percent2>', currentShareSum.toString()));
					return;
				}
				if(this.table.rows?.length>0)
				{
					if (currentShareSum <= 0 || currentShareSum > 100) {
						this.showMessage(this.LocalizeChyboveHlasky('SJ_SB_Sum_Of_Share_Percentage_Msg') + sumOfSharePercentage);
						return;
					}
				}

				// Validate share percentage sum if primary customer is present	
				const customerIdIndex = this.table.cellNames!.CUSTOMER_ID;			
				const hasPrimaryCustomer = this.table.rows.find(c => c.cells[customerIdIndex] === this.props.filter.PrimaryCustomerId);;
				if (hasPrimaryCustomer) {					
					if (currentShareSum !== 100) {
						this.showErrorAlert({ 
							message: this.LocalizeChyboveHlasky('SB_PRIMARY_CUSTOMER_SHARE_SUM_VALIDATION')							
						});
						return;
					}
				}

				const response = await apiProvider.updateList(
				convertToObjects(this.table),
				this.filter.ServiceOrderId,
				this.filter.ServiceJobId,
				this.loggedUser.DiscountLimitConfigData?.PartItemPer,
				this.loggedUser.DiscountLimitConfigData?.LaborItemPer
			);
				// Response contains the error message string or empty string for success
				const errorMessage = response.data;
				if (!errorMessage) {
					// Empty string means success
					this.refreshPreviousPage = true;
					this.closeClick();
				} else {
					// Non-empty string is the error message key
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky(errorMessage),
						options: { type: 'error' },
					});
				}
			} finally {
				this.endLoading();
			}
		},
		showMessage(message: string) {
			showAlert({
				message,
				options: {
					type: 'error',
				},
			});
		},
		async handleClose() {
			if (this.isModified) {
				if (await this.getConfirmationForModifiedTable()) {
					this.closeClick();
				}
			} else {
				this.closeClick();
			}
		},
		async loadFilter() {
			return Promise.resolve();
		},
		async rowSaved({ row: newRow }: { row: Row }) {
			const customerIdIndex = this.table.cellNames!.CUSTOMER_ID;
			const customerId = newRow.cells[customerIdIndex];
			// const vatIndex = this.table.cellNames!.VAT_AMOUNT;
			const sharePercentageColId = this.table.cellNames!.SHARE_PERCENTAGE;
			const primaryShareRowColId = this.table.cellNames!.idColumn;
			const rowId = newRow.cells[primaryShareRowColId];
			const secondaryShare = newRow.cells[sharePercentageColId];
			const rowExist = this.table.rows.find(c => c.cells[primaryShareRowColId] === rowId);
			let primaryShare = this.table.rows.length ? this.table.rows[primaryShareRowColId].cells[sharePercentageColId] : 0;

			const splitPartyIndex = this.table.cellNames!.SPLIT_PARTY_ID;
			const partyType = newRow.cells[splitPartyIndex];
			if (newRow.cells[sharePercentageColId] !== MAX_SHARE_PERCETAGE && partyType === SPLIT_PARTIES.Warranty) {
				this.showErrorAlert({ message: 'SB_WARRANTY_SHARE_VAL' });
				return;
			}
			const discountPercentColId = this.table.cellNames![COLUMN_DISCOUNT_PERCENT];
			const discountAmountColId = this.table.cellNames![COLUMN_DISCOUNT_AMOUNT];			
			const isDiscountApplicable = partyType !== SPLIT_PARTIES.Warranty
					&& partyType !== SPLIT_PARTIES.Goodwill
					&& partyType !== SPLIT_PARTIES.Dealer;
			if (isDiscountApplicable) {
				const discountPercent = +(newRow.cells[discountPercentColId] ?? 0);
				const discountAmount = +(newRow.cells[discountAmountColId] ?? 0);
				if (discountPercent < 0 || discountPercent > 100) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_PERCENT_INVALID') });
					return;
				}
				if (discountAmount < 0) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_AMOUNT_INVALID') });
					return;
				}
			}
			// if existing or new row has entered 0 split value
			if (secondaryShare <= 0) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_Zero_Percent') });
				return;
			}
			if (rowId < 0 && rowExist === undefined) {
				this.table.rows.push(newRow);
				return;
			}
		},
		onEditRow({ rowIndex, row }: { rowIndex: number, row: Row }) {
			// preserving row and its index for validation on edit button click
			this.localState.rowIndex = rowIndex;
			this.localState.row = JSON.parse(JSON.stringify(row));
		},
		updateRow(deletedRowData: { tableName: string; updateStatus: EditableStatus; rowId: number; row: Row, rowIndex: number }) {			
			this.updateTableRow(deletedRowData);			
		},
		sumOfSharePercentage() {
			const sharePercentageColId = this.table.cellNames!.SHARE_PERCENTAGE;
			const sumOfSharePercentage = this.table.rows.reduce((total: number, obj: Row) => obj.cells[sharePercentageColId] + total, 0);
			return sumOfSharePercentage;
		},
		async addOEMorDealerSplitParty(partyType: string) {
			if (this.isSplitPartyInvoiced(partyType)) {
				return;
			}

			if(partyType === 'OemWarranty' || partyType === 'OemGoodWill' ) {
				if(await this.canAddSagaSplitsInServiceJob() === false) {
					this.showMessage(this.LocalizeChyboveHlasky('Cant_Add_Saga_Splits'));
					return;
				}
			}

			if (this.table.rows.length) {
				const primaryShare = this.table.rows[this.table.cellNames!.idColumn].cells[this.table.cellNames!.SHARE_PERCENTAGE];
				if (!primaryShare) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_Share_Percent_Max') });
					return;
				}
			}
			if (partyType === 'Customer' && this.isCustomerExist(this.localState.ZakaznikId)) {
				this.showErrorAlert({ message: 'SB_Share_Customer_Added' });
				return;
			}

			if (partyType === DEALER && this.table.rows.some((item) => item.cells[this.table.cellNames!.SPLIT_PARTY_ID] === SplitPartyType[SplitPartyType.Internal]
					&& item.cells[this.table.cellNames!.INVOICE_CHARGE_TYPE_ID] === this.localState.InvoiceChargeTypeId
					&& item.cells[this.table.cellNames!.INVOICE_DEPARTMENT_ID] === this.localState.InvoiceDepartmentId)) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_CHARGE_DEPARTMENT_VAL') });
				return;
			}
			// For preserving old sequence index of row after redirection from parter select page.
			this.localState.uniqueRowIndex! -= 1;
			(this.$refs.editableSplitPartyTable as any).insertIdSequenc = this.localState.uniqueRowIndex!;

			const cells = [];
			cells.length = this.table.columns.length;
			cells[this.table.cellNames!.CUSTOMER_ID] = null;
			cells[this.table.cellNames!.SHARE_PERCENTAGE] = 0;
			cells[this.table.cellNames!.SPLIT_BILLING_ID] = null;
			cells[this.table.cellNames!.SPLIT_PARTY_ID] = null;
			switch (partyType) {
				case 'OemWarranty':
					cells[this.table.cellNames!.SPLIT_PARTY_ID] = SplitPartyType[SplitPartyType.Warranty];
					cells[this.table.cellNames!.SHARE_PERCENTAGE] = MAX_SHARE_PERCETAGE;
					cells[this.table.cellNames!.CUSTOMER_NAME] = this.oemName;
					break;
				case 'OemGoodWill':
					cells[this.table.cellNames!.SPLIT_PARTY_ID] = SplitPartyType[SplitPartyType.Goodwill];
					cells[this.table.cellNames!.CUSTOMER_NAME] = this.oemName;
					break;
				case 'Dealer':
					cells[this.table.cellNames!.SPLIT_PARTY_ID] = SplitPartyType[SplitPartyType.Internal];
					cells[this.table.cellNames!.CUSTOMER_NAME] = this.dealerName;
					cells[this.table.cellNames!.INVOICE_CHARGE_TYPE_ID] = this.localState.InvoiceChargeTypeId;
					cells[this.table.cellNames!.INVOICE_DEPARTMENT_ID] = this.localState.InvoiceDepartmentId;
					cells[this.table.cellNames!.INVOICE_CHARGE_TYPE] = this.dropdownList.InvoiceChargeTypes.find((item) => item.Value === this.localState.InvoiceChargeTypeId)?.Text;
					cells[this.table.cellNames!.INVOICE_DEPARTMENT] = this.dropdownList.InvoiceDepartments.find((item) => item.Value === this.localState.InvoiceDepartmentId)?.Text;
					if (this.dropdownList.InvoiceChargeTypes.length > DEFAULT_INDEX) {
						this.localState.InvoiceChargeTypeId = this.dropdownList.InvoiceChargeTypes[DEFAULT_INDEX].Value;
					}
					if (this.dropdownList.InvoiceDepartments.length > DEFAULT_INDEX) {
						this.localState.InvoiceDepartmentId = this.dropdownList.InvoiceDepartments[DEFAULT_INDEX].Value;
					}
					break;
				case 'Customer': {
					const response = await apiProvider.fetchCustomerType(this.localState.ZakaznikId);
					cells[this.table.cellNames!.SPLIT_PARTY_ID] = response?.data;
					cells[this.table.cellNames!.CUSTOMER_NAME] = this.localState.ZakaznikIdText;
					cells[this.table.cellNames!.CUSTOMER_ID] = this.localState.ZakaznikId;
					this.localState.ZakaznikId = null;
					this.localState.ZakaznikIdText = null;
					break;
				}
			}
			this.localState.defaultRowModel.cells = cells;
			(this.$refs.editableSplitPartyTable as any).createRow();
		},
		isCustomerExist(customerId: number | null): boolean {
			if (customerId) {
				return  this.isSplitPartyExist(customerId, true);
			}
			return false;
		},
		isPrimaryCustomerInvoiced(): boolean {
			return !!this.localState.splitPartyInvoiceDetails?.find(x =>
				x.IsBilled && x.IsPrimaryCustomer
			);
		},
		isSplitPartyInvoiced(partyType: string, primaryCustomerId: number | null = null): boolean {
			let splitPartyType: string | null = null;
			let customerId: number | null = null;
			switch (partyType) {
				case 'OemWarranty':
					splitPartyType = SplitPartyType[SplitPartyType.Warranty];
					break;
				case 'OemGoodWill':
					splitPartyType = SplitPartyType[SplitPartyType.Goodwill];
					break;
				case 'Dealer':
					splitPartyType = SplitPartyType[SplitPartyType.Internal];
					break;
				case 'Customer':
					customerId = primaryCustomerId ?? this.localState.ZakaznikId;
					break;
			}
			const partyDetails: ISplitPartyInvoiceDetail | undefined = this.localState.splitPartyInvoiceDetails?.find(x => (x.IsBilled)
				&& (splitPartyType !== null ? x.SplitPartyTypeName === splitPartyType : x.CustomerId === customerId));
				if (partyDetails) {
					this.showMessage(`${partyDetails.CustomerName} (${this.LocalizePopisostatni(`PI_${partyDetails.SplitPartyTypeName}`)}) 
						${this.LocalizeChyboveHlasky('SB_Party_Cant_Add')}`);
					this.localState.ZakaznikId = null;
					this.localState.ZakaznikIdText = null;
					return true;
			}
			return false;
		},
		async getPartyInvoicedDetails(serviceOrderId: number) {
			this.localState.splitPartyInvoiceDetails = [];
			this.startLoading();
			const response = await apiProvider.getPartyInvoicedDetails(serviceOrderId);
			this.endLoading();
			if (response.data) {
				this.localState.splitPartyInvoiceDetails = response.data as ISplitPartyInvoiceDetail[];				
			}
		},

		async canAddSagaSplitsInServiceJob() {
			this.startLoading();
			const response = await apiProvider.canAddSagaSplits(this.filter.ServiceJobId, this.filter.ServiceOrderId);
			this.endLoading();
			return response?.data;
		},
		isDiscountReadOnly(row: Row): boolean {
			const splitPartyColId = this.table.cellNames!.SPLIT_PARTY_ID;
			const partyType = row.cells[splitPartyColId];
			return partyType === SPLIT_PARTIES.Dealer
				|| partyType === SPLIT_PARTIES.Goodwill
				|| partyType === SPLIT_PARTIES.Warranty;
		},
		onDiscountPercentChange(value: any, row: Row, columnId: number, rowModel: any): void {
			const discountPercentColId = this.table.cellNames![COLUMN_DISCOUNT_PERCENT];
			const discountAmountColId = this.table.cellNames![COLUMN_DISCOUNT_AMOUNT];
			const discountPercent = value;

			if (discountPercent !== null && discountPercent !== undefined && discountPercent !== '') {
				const percentValue = +discountPercent;
				if (percentValue <= 0 || percentValue > 100) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_PERCENT_INVALID') });
					rowModel[discountPercentColId] = null;
					rowModel[discountAmountColId] = null;
					return;
				}

				const configuredDiscountLimit = this.loggedUser.DiscountLimitConfigData?.PartItemPer;
				if (configuredDiscountLimit !== undefined && configuredDiscountLimit !== null && percentValue > configuredDiscountLimit) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_PERCENT_EXCEEDS_LIMIT') });
					rowModel[discountPercentColId] = null;
					rowModel[discountAmountColId] = null;
					return;
				}
				rowModel[discountPercentColId] = percentValue;
				// Valid percent entered — clear the amount field
				rowModel[discountAmountColId] = null;
			}
		},
		onDiscountAmountChange(value: any, row: Row, columnId: number, rowModel: any): void {
			const discountPercentColId = this.table.cellNames![COLUMN_DISCOUNT_PERCENT];
			const discountAmountColId = this.table.cellNames![COLUMN_DISCOUNT_AMOUNT];
			const discountAmount = value;

			if (discountAmount !== null && discountAmount !== undefined && discountAmount !== '') {
				const amountValue = +discountAmount;
				if (amountValue <= 0) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_AMOUNT_INVALID') });
					rowModel[discountAmountColId] = null;
					return;
				}
				// Valid amount entered — clear the percent field
				rowModel[discountPercentColId] = null;
				rowModel[discountAmountColId] = discountAmount;
			}
		},
	},
});
